import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import OrganisationLayout from "../layout/OrganisationLayout";
import ReportIssue from "../../Components/ReportIssue";

export default function OrganisationGroupsReportAnIssue() {
  return (
    <OrganisationLayout>
      <Container fluid>
        <Row className="justify-content-center">
          <Col xxl={5} xl={5} lg={6} className="mt-4">
            <div className="cmn-card-color mt-4 pb-4 pt-4">
              <div className="back-page-title">
                <Link to="/organisations/help-support">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      d="M13.75 5.5L8.25 11L13.75 16.5"
                      stroke="#CCD2E3"
                      strokeWidth="2"
                    />
                  </svg>
                </Link>
              </div>
              <ReportIssue isBrowse={false} reportId="" />
            </div>
          </Col>
        </Row>
      </Container>
    </OrganisationLayout>
  );
}
